// extracted by mini-css-extract-plugin
export var orderDetails = "_mp-2";
export var orderImage = "_mp-1";
export var orderMeta = "_mp-3";
export var orderSummary = "_mp-0";
export var rightArrow = "_mp-4";